export const newCustomerSearchParams = params => {
  const searchParams = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    filtermethod: 'AND',
  };
  let newParams = { ...params };
  if (
    Object.keys(params).some(key => Object.keys(searchParams).includes(key))
  ) {
    newParams = { ...searchParams, ...params };
  }

  return newParams;
};
